// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IRp-Y","label":"styles_label__3IOWR"};